import { YAAS_CLIENT_OAUTH } from "@solomon-apps/config";
import type { OAuthConfig } from "@solomon-apps/shared";

export const CLIENT_OAUTH_CONFIG: OAuthConfig = YAAS_CLIENT_OAUTH;
